import ImageSpacerComponent from './ImageSpacerComponent'

export default ImageSpacerComponent
